import React, { useEffect, useMemo } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { trackPageLifecycle } from '../lib/customerEventTracker';

const TermsOfService = () => {
  const { t } = useLanguage();
  useEffect(
    () => trackPageLifecycle({
      funnel_name: 'TERMS_PAGE',
      form_name: 'TermsOfService',
      service_code: null,
      open_event_name: 'terms_page_open',
    }),
    [],
  );

  const sections = useMemo(() => [
    { h: t('terms.s1_h', '1. Acceptance'), p: t('terms.s1_p', '') },
    { h: t('terms.s2_h', '2. Services'), p: t('terms.s2_p', '') },
    { h: t('terms.s3_h', '3. Your responsibilities'), p: t('terms.s3_p', '') },
    { h: t('terms.s4_h', '4. Fees & payments'), p: t('terms.s4_p', '') },
    { h: t('terms.s5_h', '5. Limitation of liability'), p: t('terms.s5_p', '') },
    { h: t('terms.s6_h', '6. Contact'), p: t('terms.s6_p', '') },
  ], [t]);

  return (
    <div className="pt-28 pb-16">
      <section className="py-10 hero-gradient">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#0f2540] mb-3">
            {t('terms.hero_title', 'Terms of')} <span className="text-[#14A098]">{t('terms.hero_accent', 'Service')}</span>
          </h1>
          <p className="text-gray-600">{t('terms.updated', 'Last updated: July 2025')}</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 md:px-8 py-14 space-y-6 text-gray-700 leading-relaxed">
        {sections.map((s) => (
          <div key={s.h}>
            <h2 className="text-xl font-bold text-[#0f2540] mb-2">{s.h}</h2>
            <p>{s.p}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default TermsOfService;
